import { Typography } from '@euler/app/components/typography';
import { formatDuration } from '@euler/utils/datetime';
import { formatDateTime } from '@euler/utils/formatters';
import { memo } from 'react';
import { View } from 'react-native';
import { useBoardUnit } from '../../functions/useBoardUnit';
import { WorkshopJob } from '../../functions/workshopJobFromItem';
import { workshopBoardColors as colors } from '../../workshopBoardColors';
import { kBoardRowHeight } from '../board-table/boardColumns';
import { JobStatusCell } from './JobStatusCell';
import { kJobColumns } from './columns';

/**
 * One open job: the car, the work, who does it in which team, and since
 * when; a job not begun has no start and no time yet.
 */
export const JobRow = memo(({ job, now }: { job: WorkshopJob; now: Date }) => {
  const u = useBoardUnit();
  const { startedAt } = job;
  const cell = (flex: number, text: string | null, color: string) => (
    <Typography.Text
      size={u(26)}
      color={text ? color : colors.faint}
      numberOfLines={1}
      style={{ flex, fontVariant: ['tabular-nums'] }}
    >
      {text || '—'}
    </Typography.Text>
  );
  return (
    <View
      style={{
        height: u(kBoardRowHeight),
        flexDirection: 'row',
        alignItems: 'center',
        borderBottomWidth: 1,
        borderBottomColor: colors.line,
      }}
    >
      <Typography.Text
        size={u(34)}
        bold
        color={colors.foreground}
        numberOfLines={1}
        style={{ flex: kJobColumns.plate.flex }}
      >
        {job.licensePlateNo}
      </Typography.Text>
      {cell(kJobColumns.name.flex, job.name, colors.foreground)}
      {cell(kJobColumns.technician.flex, job.technicianName, colors.foreground)}
      {cell(kJobColumns.team.flex, job.team, colors.muted)}
      {cell(
        kJobColumns.startedAt.flex,
        startedAt ? formatDateTime(startedAt, 'MM-dd HH:mm') : null,
        colors.muted,
      )}
      {cell(
        kJobColumns.elapsed.flex,
        startedAt
          ? formatDuration(Math.max(now.getTime() - startedAt.getTime(), 0))
          : null,
        colors.foreground,
      )}
      <JobStatusCell status={job.status} flex={kJobColumns.status.flex} />
    </View>
  );
});
